import styled from 'styled-components';

// Espejo del wrapper Tabs+Outlet hermano de GeneralView/styles.ts
// (`/work-orders`) y GeneralViewRoute/styles.ts (`/surveillance-route`) —
// reutiliza el `Container` compartido de workOrders en vez de reinventar
// uno propio.
import { Container } from '../../components/MainStyledComponents';

export const ContainerStyled = styled(Container)`
  position: relative;
  flex-direction: column;
  align-items: flex-start;
  border-radius: ${({ theme }) => theme.spaces.s}rem;
`;
